/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SalesTaxRateDto } from '@gh/builder-shared-data';

export type SalesTaxRateListItem = SalesTaxRateDto;

export const getSalesTaxRateListItemId = (item: SalesTaxRateListItem) => item.id;
